import { BaseModel } from "../base.model";
import { ApiSettingsModel } from "../tenant/api-settings.model";
import { CacheModel } from "../tenant/cache.model";
import { DatabaseSettingsModel } from "../tenant/database-settings.model";

export class BusinessUnit extends BaseModel{
    name?: string; 
    domain?: string;
    tenantId?: string; 
    logoImageUri?: string; 
    isDefault?: boolean;
    databaseSettings?: DatabaseSettingsModel;
    apiSettings?: ApiSettingsModel[];
    cacheSettings?:  CacheModel;
}
